import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Kanban: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M6 5v11' }],
    ['path', { d: 'M12 5v6' }],
    ['path', { d: 'M18 5v14' }],
  ],
];

export default Kanban;
